import { assignSafe } from '@summit/core';
import { ListFooter } from './list-footer';
export class ListGroup<T> {
  groupName: string | number;
  groupId: string;
  value: string | number;
  groupDepth: number;
  baseElement: T;
  elements = new Array<T>();
  isGroup: boolean;
  isReduced: boolean;
  displayMenu = false;
  siblingCount: number; //used for footer

  constructor(jsonData?: Partial<ListGroup<T>>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
    this.siblingCount = 0;
  }

  getFooter(): ListFooter<T> {
    return new ListFooter({
      groupName: this.groupName,
      groupId: this.groupId,
      value: this.value,
      groupDepth: this.groupDepth,
      baseElement: this.baseElement,
      elements: this.elements,
      isGroupFooter: true,
      childGroupCount: this.siblingCount
    });
  }
}
